import React from 'react';
import { Button, Icon } from 'antd';

export default function WalkthroughFooter({
  videoIndex,
  stepCount,
  currentVideo,
  unlockHint,
  canLifecycle,
  isFirstVideo,
  isLastVideo,
  videosLength,
  previousLabel,
  nextLabel,
  previousHeading,
  canContinue,
  dirty,
  planExpired,
  submissionRequest,
  onCancel,
  onSave,
  onPrevious,
  onContinue,
  onBack,
}) {
  const showVideoNav = videosLength > 1;
  const showNext = canLifecycle || !isLastVideo;
  const showExit = !canLifecycle;

  return (
    <footer className="testing-exercising-walkthrough__footer">
      <div className="testing-exercising-walkthrough__footer-copy">
        <p className="testing-exercising-walkthrough__footer-step">
          Video {videoIndex + 1} of {stepCount}
          {currentVideo?.heading ? ` · ${currentVideo.heading}` : ''}
        </p>
        <p>{unlockHint}</p>
      </div>
      <div className="testing-exercising-walkthrough__footer-actions btn-container">
        {canLifecycle ? (
          <div className="testing-exercising-walkthrough__footer-secondary">
            <Button
              className="testing-exercising-walkthrough__cancel-btn"
              onClick={onCancel}
              loading={submissionRequest}
              disabled={planExpired}
            >
              Cancel
            </Button>
            <Button onClick={onSave} loading={submissionRequest} disabled={!dirty || planExpired}>
              Save progress
            </Button>
          </div>
        ) : null}

        {showVideoNav || showNext ? (
          <div
            className="testing-exercising-walkthrough__footer-nav"
            role="navigation"
            aria-label="Video navigation"
          >
            {showVideoNav ? (
              <Button
                className="testing-exercising-walkthrough__video-prev"
                icon="arrow-left"
                disabled={isFirstVideo}
                loading={submissionRequest}
                onClick={onPrevious}
                title={previousHeading || undefined}
              >
                {previousLabel}
              </Button>
            ) : null}
            {showNext ? (
              <Button
                type="primary"
                className="testing-exercising-walkthrough__video-next"
                disabled={!canContinue}
                loading={submissionRequest}
                onClick={onContinue}
              >
                {nextLabel} {!isLastVideo ? <Icon type="arrow-right" /> : null}
              </Button>
            ) : null}
          </div>
        ) : null}

        {showExit ? (
          <Button
            className="testing-exercising-walkthrough__footer-exit"
            icon="appstore"
            onClick={onBack}
          >
            Back to scenario hub
          </Button>
        ) : null}
      </div>
    </footer>
  );
}
